
import React, { useState, useEffect } from 'react';
import {useLocation} from 'react-router-dom';
import { useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import { Row, Col, Container, Table } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import { useForm  } from 'react-hook-form'
import './style.css'
import { OutboundEMSService } from '../../services/OutboundEMSService'
import { string } from 'yup';
import { AdditionalFieldsService } from '../../services/AdditionalFieldsService'

let formValues ={
    equipmentItemId: string,
    serialNumber: string,
    tagNumber: string,
    groupName: string,
    categoryName: string,
    makeName: string,
    modelName: string,
    advertisedPrice: string,
    meterReadingHours: string,
    modelYear: string,
    store: string,
    storeShipState: string,
    phone: string,
    isNew: string,
    description: string,
    storeNumber: string,
    isActive: string,
    isHotList: string,
    attachmentList: string,
    makeOrder: string,
    ba: string,
    rule: string
}

const OutboundEMSAPIEdit=()=> {
    const location = useLocation();
    const navigate = useNavigate();
    const [check1, setCheck1] = useState();
    const [check2, setCheck2] = useState();
    const [check3, setCheck3] = useState();
    const [items, setItems] = useState([]);


    const { 
      register, watch, handleSubmit,
      // setValue, resetValue,unregister, 
      // resetField, setError, clearErrors, 
      // setFocus, getValues, trigger, control,
      formState: { 
          errors, 
         // isDirty, dirtyFields, touchedFields, isSubmitting, isSubmitted, isSubmitSuccessful, isValidating, isValid, submitCount 
      } } 
  = useForm(
    //{ defaultValues: { Id: 0, Username: '', Password1: '', RoleId:'', ProfileId: '', Status: 'Inactive' } }
    );
    useEffect(() => {
        const getComments = async () => {
            const data = await AdditionalFieldsService.getAdditionalFieldsRule(location.state.data.rule);
            setItems(data);
            console.log('Data For RULE003 = ',data);   
        };      
        getComments();          
  }, []);

    const onSubmit = (data, event) => {
      event.preventDefault();
      OutboundEMSService.getEMS(location.state.data.equipmentItemId).then((da)=>{
        formValues = {
            id: da.id,
            equipmentItemId: da.equipmentItemId,
            serialNumber: data.serialNumber,
            tagNumber: data.tagNumber,
            groupName: data.groupName,
            categoryName: data.categoryName,
            makeName: data.makeName,
            modelName: data.modelName,
            advertisedPrice: data.advertisedPrice,
            meterReadingHours: data.meterReadingHours,
            modelYear: data.modelYear,
            store: data.store,
            storeShipState: data.storeShipState,
            phone: data.phone,
            isNew: data.isNew.toString(),
            url:da.url,
            description: data.description,
            storeNumber: data.storeNumber,
            isActive: data.isActive.toString(),
            isHotList: data.isHotList.toString(),
            attachmentList: data.attachmentList,
            makeOrder: data.makeOrder,
            ba: data.ba,
            extraField1: da.extraField1,
            extraField2: da.extraField2,
            status: da.status
        }    
        OutboundEMSService.editEMS(formValues).then((data=>{
            toast.success('Data Updated Successfully',{ position: 'bottom-center'});
        }))  
  
    })
  }
  


    const CancelAction = ((e) => {
      e.preventDefault();
      navigate('/Configurations');
    })

    const UnPublish = ((e) => {
        e.preventDefault();
        OutboundEMSService.getEMS(location.state.data.equipmentItemId).then((da)=>{
            formValues ={
                id: da.id,
                equipmentItemId: location.state.data.equipmentItemId,
                serialNumber: location.state.data.serialNumber,
                tagNumber: location.state.data.tagNumber,
                groupName: location.state.data.groupName,
                categoryName: location.state.data.categoryName,
                makeName: location.state.data.makeName,
                modelName: location.state.data.modelName,
                advertisedPrice: location.state.data.advertisedPrice,
                meterReadingHours: location.state.data.meterReadingHours,
                modelYear: location.state.data.modelYear,
                store: location.state.data.store,
                storeShipState: location.state.data.storeShipState,
                phone: location.state.data.phone,
                isNew: location.state.data.isNew.toString(),
                description: location.state.data.description,
                storeNumber: location.state.data.storeNumber,
                isActive: location.state.data.isActive,
                isHotList: location.state.data.isHotList,
                attachmentList: location.state.data.attachmentList,
                makeOrder: location.state.data.makeOrder,
                ba: location.state.data.ba,
                rule: location.state.data.rule
            }    

            
            console.log('FormID Cancelled ===>',formValues);
            OutboundEMSService.deleteEMS(formValues)
            .then(nav =>
                { 
                    toast.success('Un Published Successfully',{ position: 'bottom-center'});                    
                })
            .catch((error)=>{
                console.log('Error = ',error)
            });
        });

    })
    const booleanify = (value: string): boolean => {
        const truthy: string[] = [
            'true',
            'True',
            '1'
        ]
      
        return truthy.includes(value)
      }

      return (
            <>
 <Container>
        <Row>
        <Col  md="8">
                        <div className="heading">
                            <h5 className = "mainheading">EMS API Edit Form</h5>
                            <hr/>
                        </div>
                    
                        <form onSubmit={handleSubmit(onSubmit)}>

                        <input hidden className="input" type="text" {...register("id")}  id="id" placeholder="ID"></input>
                        <table>

                        <tr key= { Math.random() }>
                            <td>
                                <label className="BlueLabel">Equipment ID</label>
                                <input disabled defaultValue = { location.state.data.equipmentItemId } className="input" type="text" {...register("equipmentItemId")}  id="equipmentItemId" placeholder="equipmentItemId"></input>
                                <h2>{errors.equipmentItemId && <p>{errors.equipmentItemId.message}</p>}</h2>
                            </td>
                            <td>
                            <label className="BlueLabel">Serial Number</label>
                            <input defaultValue = { location.state.data.serialNumber } className="input" type="text" {...register("serialNumber")}  id="serialNumber" placeholder="serialNumber"></input>
                                <h2>{errors.serialNumber && <p>{errors.serialNumber.message}</p>}</h2>
                            </td>
                            <td>
                            <label className="BlueLabel">Tag Number</label>
                            <input defaultValue = { location.state.data.tagNumber } className="input" type="text" {...register("tagNumber")}  id="tagNumber" placeholder="tagNumber"></input>
                                <h2>{errors.tagNumber && <p>{errors.tagNumber.message}</p>}</h2>
                            </td>

                        </tr>

                        <tr key= { Math.random() }>
                            <td>
                            <label className="BlueLabel">Group Name</label>
                            <input defaultValue = { location.state.data.groupName } className="input" type="text" {...register("groupName")}  id="groupName" placeholder="groupName"></input>
                                <h2>{errors.groupName && <p>{errors.groupName.message}</p>}</h2>
                            </td>
                            <td>
                            <label className="BlueLabel">Category Name</label>
                            <input defaultValue = { location.state.data.categoryName } className="input" type="text" {...register("categoryName")}  id="categoryName" placeholder="categoryName"></input>
                                <h2>{errors.categoryName && <p>{errors.categoryName.message}</p>}</h2>
                            </td>
                            <td>
                            <label className="BlueLabel">Make Name</label>
                            <input defaultValue = { location.state.data.makeName } className="input" type="text" {...register("makeName")}  id="makeName" placeholder="makeName"></input>
                                <h2>{errors.makeName && <p>{errors.makeName.message}</p>}</h2>
                            </td>

                        </tr> 

                        <tr key= { Math.random() }>
                            <td>
                            <label className="BlueLabel">Modal Name</label>
                            <input defaultValue = { location.state.data.modelName } className="input" type="text" {...register("modelName")}  id="modelName" placeholder="modelName"></input>
                                <h2>{errors.modelName && <p>{errors.modelName.message}</p>}</h2>
                            </td>
                            <td>
                            <label className="BlueLabel">Advertised Price</label>
                            <input defaultValue = { location.state.data.advertisedPrice } className="input" type="text" {...register("advertisedPrice")}  id="advertisedPrice" placeholder="advertisedPrice"></input>
                                <h2>{errors.advertisedPrice && <p>{errors.advertisedPrice.message}</p>}</h2>
                            </td>
                            <td>
                            <label className="BlueLabel">Reading Hours</label>
                            <input defaultValue = { location.state.data.meterReadingHours } className="input" type="text" {...register("meterReadingHours")}  id="meterReadingHours" placeholder="meterReadingHours"></input>
                                <h2>{errors.meterReadingHours && <p>{errors.meterReadingHours.message}</p>}</h2>
                            </td>

                        </tr> 


                        <tr key= { Math.random() }>
                            <td>
                            <label className="BlueLabel">Modal Year</label>
                            <input  defaultValue = { location.state.data.modelYear } className="input" type="text" {...register("modelYear")}  id="modelYear" placeholder="modelYear"></input>
                                <h2>{errors.modelYear && <p>{errors.modelYear.message}</p>}</h2>
                            </td>
                            <td>
                            <label className="BlueLabel">Store</label>
                            <input defaultValue = { location.state.data.store } className="input" type="text" {...register("store")}  id="store" placeholder="store"></input>
                                <h2>{errors.store && <p>{errors.store.message}</p>}</h2>
                            </td>
                            <td>
                            <label className="BlueLabel">Store Ship State</label>
                            <input  defaultValue = { location.state.data.storeShipState } className="input" type="text" {...register("storeShipState")}  id="storeShipState" placeholder="storeShipState"></input>
                                <h2>{errors.storeShipState && <p>{errors.storeShipState.message}</p>}</h2>
                            </td>
                        </tr> 



                        <tr key= { Math.random() }>
                            <td>
                            <label className="BlueLabel">Primary Phone</label>
                            <input defaultValue = { location.state.data.phone } className="input" type="text" {...register("phone")}  id="phone" placeholder="phone"></input>
                                <h2>{errors.phone && <p>{errors.phone.message}</p>}</h2>
                            </td>
                            
                            
                            {/* <td>
                            <label className="BlueLabel">isNew</label>
                             <input  defaultValue = { location.state.data.isNew } className="input" type="text" {...register("field15")}  id="field15" placeholder="Field 15"></input>
                                <h2>{errors.field15 && <p>{errors.field15.message}</p>}</h2>
                            </td> */}

                        <td>
                            <label  className="BlueLabel">Is New.........</label>
                              <input className="checkbox" type="checkbox" onClick={(e)=> setCheck1(e.target.checked)} checked={booleanify(location.state.data.isNew)}  {...register("isNew")}  id="isNew" placeholder="isNew"></input>
                              <h2>{errors.isNew && <p>{errors.isNew.message}</p>}</h2>
                          </td>



                            <td>
                            <label className="BlueLabel">Description</label>
                            <input defaultValue = { location.state.data.description } className="input" type="text" {...register("description")}  id="description" placeholder="description"></input>
                                <h2>{errors.description && <p>{errors.description.message}</p>}</h2>
                            </td> 
                        </tr> 


                        <tr key= { Math.random() }>
                            <td>
                            <label className="BlueLabel">Store Number</label>
                            <input  defaultValue = { location.state.data.storeNumber } className="input" type="text" {...register("storeNumber")}  id="storeNumber" placeholder="storeNumber"></input>
                                <h2>{errors.storeNumber && <p>{errors.storeNumber.message}</p>}</h2>
                            </td>
                            {/* <td>
                            <label className="BlueLabel">Is Active</label>
                            <input defaultValue = { location.state.data.isActive } className="input" type="text" {...register("field18")}  id="field18" placeholder="Field 18"></input>
                                <h2>{errors.field18 && <p>{errors.field18.message}</p>}</h2>
                            </td> */}

                            <td>
                            <label  className="BlueLabel">Is Active.....</label>
                              <input className="checkbox" type="checkbox" onClick={(e)=> setCheck2(e.target.checked)} checked={booleanify(location.state.data.isActive)}  {...register("isActive")}  id="isActive" placeholder="isActive"></input>
                              <h2>{errors.isActive && <p>{errors.isActive.message}</p>}</h2>
                          </td>

                            {/* <td>
                            <label className="BlueLabel">Is Hot List</label>
                            <input  defaultValue = { location.state.data.isHotList } className="input" type="text" {...register("field19")}  id="field19" placeholder="Field 19"></input>
                                <h2>{errors.field19 && <p>{errors.field19.message}</p>}</h2>
                            </td> */}

                            <td>
                            <label  className="BlueLabel">Is Hotlist ..</label>
                              <input className="checkbox" type="checkbox" onClick={(e)=> setCheck3(e.target.checked)} checked={booleanify(location.state.data.isHotList)}  {...register("isHotList")}  id="isHotList" placeholder="isHotList"></input>
                              <h2>{errors.isHotList && <p>{errors.isHotList.message}</p>}</h2>
                          </td>


                        </tr> 


                        <tr key= { Math.random() }>
                            <td>
                            <label className="BlueLabel">Attachment List</label>
                            <input defaultValue = { location.state.data.attachmentList } className="input" type="text" {...register("attachmentList")}  id="attachmentList" placeholder="attachmentList"></input>
                                <h2>{errors.attachmentList && <p>{errors.attachmentList.message}</p>}</h2>
                            </td>
                            <td>
                            <label className="BlueLabel">Make Order</label>
                            <input  defaultValue = { location.state.data.makeOrder } className="input" type="text" {...register("makeOrder")}  id="makeOrder" placeholder="makeOrder"></input>
                                <h2>{errors.makeOrder && <p>{errors.makeOrder.message}</p>}</h2>
                            </td>

                            <td>
                            <label className="BlueLabel">BA</label>
                            <input  defaultValue = { location.state.data.ba } className="input" type="text" {...register("ba")}  id="ba" placeholder="ba"></input>
                                <h2>{errors.ba && <p>{errors.ba.message}</p>}</h2>
                            </td>
                        </tr>  
                        
                        </table>
                        <div className="container">
                            <div className="row">
                                <div className="col md-3 sm-3 xs-2">
                                    <span>
                                      <button className="submit" type="submit">Update</button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </form>  
                    <ToastContainer/>                                
             </Col>
            <Col  md="2">
                        <div className="heading">
                            <h5 className = "operation">Operation</h5>
                            <hr/>
                        </div>

                <span>
                  <button className="viewButton" onClick={(e)=>CancelAction(e)} type="button">Cancel</button>
                </span>
                <span>
                  <button className="viewButton" onClick={(e)=>UnPublish(e)} type="button">UnPublish</button>
                </span>
                <hr/>
                <span>
                    <img src= { location.state.data.url } width="250" height="250"/>
                </span>
              </Col>

              <Col md="2">
              <div className="heading">
                <h5 className = "operation">Additional</h5>
                <hr/>
            </div>
            <Table striped bordered hover variant="dark">
                    <thead>
                            <tr key= { Math.random() }>
                                <th>Field</th>
                                <th>Value</th>
                            </tr>
                    </thead>
                    <tbody>

                    { 
                        items.map((pro) => {
                        return <>
                            <tr key= { Math.random() }>
                                <td>{pro.fieldName}</td>
                                <td> { pro.fieldValue }</td>
                            </tr>
                        </>
                        })                  
                    }
                    </tbody>
                    </Table>

            </Col>
             </Row>
             </Container>
            </>
        );
  }
 
export default OutboundEMSAPIEdit;